export const DEFAULT_WEBSITE_CONTENT = {
  // Default to one of the Storefront themes (mirrors the PHP template picker)
  template: 'classic',
  enabledSections: {
    hero: true,
    map: true,
    howItWorks: true,
    valueProps: true,
    driverBusiness: true,
    download: true,
  },
  sectionOrder: ['hero', 'map', 'howItWorks', 'valueProps', 'driverBusiness', 'download'],
  branding: {
    brandName: 'Plukk',
    logoUrl: '',
    faviconUrl: '',
  },
  seo: {
    title: 'Plukk | Ride the future',
    description: 'Book reliable rides in minutes with Plukk.',
    ogImage: '',
  },
  hero: {
    title: 'Go anywhere with Plukk',
    subtitle: 'Request a ride in minutes and get picked up by trusted drivers.',
    primaryCtaLabel: 'See prices',
    secondaryCtaLabel: 'Schedule',
    image: '',
  },
  map: {
    title: 'Drivers near you',
  },
  howItWorks: {
    title: 'How Plukk works',
    steps: [
      {
        title: 'Request a ride',
        description: 'Open the app and enter your destination. See available rides and prices upfront.',
        icon: 'location',
      },
      {
        title: 'Get picked up',
        description: 'Your driver arrives at your location. Track their arrival in real time.',
        icon: 'car',
      },
      {
        title: 'Enjoy the ride',
        description: 'Sit back and relax. Pay automatically when you arrive.',
        icon: 'star',
      },
    ],
  },
  valueProps: {
    cards: [
      {
        title: 'Ride with Plukk',
        description: 'Request a ride and get picked up by a nearby driver in minutes.',
        link: '/login',
        linkText: 'Get a ride',
        image: '',
      },
      {
        title: 'Drive with Plukk',
        description: 'Set your own hours and earn money on your schedule.',
        link: '/login',
        linkText: 'Become a driver',
        image: '',
      },
    ],
    safety: {
      title: 'Safety is a top priority',
      description:
        "Whether you're in the back seat or behind the wheel, your safety is essential.",
      link: '/about-us',
      linkText: 'Learn about safety',
      features: [
        { title: 'Driver screening', description: 'Background checks before driving.' },
        { title: 'Real-time support', description: '24/7 customer support.' },
        { title: 'Trip tracking', description: 'Share ride status with loved ones.' },
      ],
    },
  },
  driver: {
    title: 'Make money on your schedule',
    description: 'Drive when you want and keep more of what you earn.',
    primaryCtaLabel: 'Get started',
    primaryCtaLink: '/login',
    secondaryCtaLabel: 'Learn more',
    secondaryCtaLink: '/about-us',
    image: '',
  },
  business: {
    title: 'Plukk for Business',
    description: 'Transform the way your company moves with centralized controls.',
    link: '/contact-us',
    linkText: 'Get started',
    features: [
      { title: 'Simplified billing', description: 'One monthly invoice for all rides.' },
      { title: 'Central dashboard', description: 'Track rides and manage users.' },
      { title: 'Expense integration', description: 'Works with your expense tools.' },
    ],
  },
  download: {
    title: 'Download the apps and go',
    subtitle: 'Available for iOS and Android. Get the app that fits your needs.',
    showApple: true,
    showAndroid: true,
  },
  shop: {
    enabled: true,
    currency: 'NOK',
    banners: [
      {
        id: 'welcome',
        title: 'Plukk Shop',
        subtitle: 'Passes, perks, and official merch.',
        image: '',
        link: '/shop',
        buttonText: 'Shop now',
        variant: 'hero',
        active: true,
      },
      {
        id: 'rides',
        title: 'Ride Pass',
        subtitle: 'Bundle rides and save every month.',
        image: '',
        link: '/subscriptions',
        buttonText: 'View plans',
        variant: 'split',
        active: true,
      },
    ],
    campaigns: [
      {
        id: 'winter-deal',
        title: 'Winter deal',
        description: 'Limited-time savings on selected items.',
        active: true,
        startsAt: '',
        endsAt: '',
        discountPercent: 15,
        productIds: ['plukk-hoodie'],
        badgeText: '15% OFF',
      },
    ],
    subscriptions: [
      {
        id: 'ride-pass-monthly',
        title: 'Ride Pass (Monthly)',
        description: 'Monthly perks with predictable pricing.',
        price: 199,
        interval: 'month',
        published: true,
        perks: ['Priority support', 'Member-only deals', 'Monthly ride credits'],
      },
    ],
    auctions: [
      {
        id: 'founders-pack',
        title: 'Founders Pack',
        description: 'Limited edition drop. Bid to win.',
        image: '',
        published: false,
        startsAt: '',
        endsAt: '',
        startingBid: 100,
        bidIncrement: 10,
      },
    ],
    products: [
      {
        id: 'plukk-gift-card',
        title: 'Plukk Gift Card',
        description: 'Send rides, credit, or perks. Delivered instantly.',
        price: 250,
        image: '',
        published: true,
        category: 'digital',
      },
      {
        id: 'plukk-ride-pass',
        title: 'Plukk Ride Pass',
        description: 'Bundle rides and save with a monthly pass.',
        price: 199,
        image: '',
        published: true,
        category: 'digital',
      },
      {
        id: 'plukk-hoodie',
        title: 'Plukk Hoodie',
        description: 'Soft, warm, and built for everyday city runs.',
        price: 499,
        image: '',
        published: true,
        category: 'merch',
      },
    ],
  },
  navigation: {
    rideLinks: [
      { label: 'home', path: '/', visible: true },
      { label: 'book_a_ride', path: '/addbookings', visible: true, requiresAuth: true },
      { label: 'shop', path: '/shop', visible: true },
    ],
    driveLinks: [
      { label: 'become_a_driver', path: '/login', visible: true },
      { label: 'become_partner', path: '/contact-us', visible: true },
    ],
    aboutLinks: [
      { label: 'about_us', path: '/about-us', visible: true },
      { label: 'contact_us', path: '/contact-us', visible: true },
      { label: 'privacy_policy', path: '/privacy-policy', visible: true },
    ],
    footerCompany: [
      { label: 'about_us', path: '/about-us', visible: true },
      { label: 'contact_us', path: '/contact-us', visible: true },
      { label: 'privacy_policy', path: '/privacy-policy', visible: true },
    ],
    footerProducts: [
      { label: 'ride', path: '/', visible: true },
      { label: 'drive', path: '/login', visible: true },
      { label: 'shop', path: '/shop', visible: true },
    ],
    footerLegal: [
      { label: 'privacy_policy', path: '/privacy-policy', visible: true },
      { label: 'terms', path: '/privacy-policy', visible: true },
    ],
  },
};

const mergeDeep = (target, source) => {
  if (!source) return target;
  const output = { ...target };
  Object.keys(source).forEach((key) => {
    if (Array.isArray(source[key])) {
      output[key] = source[key];
    } else if (source[key] && typeof source[key] === 'object') {
      output[key] = mergeDeep(target[key] || {}, source[key]);
    } else if (source[key] !== undefined) {
      output[key] = source[key];
    }
  });
  return output;
};

export const getWebsiteContent = (settings, locale) => {
  const base = DEFAULT_WEBSITE_CONTENT;
  const content = settings?.websiteContent || {};
  const localized = locale && content?.translations?.[locale] ? content.translations[locale] : {};
  return mergeDeep(base, mergeDeep(content, localized));
};

export const getPartnerWebsiteContent = (settings, partner, locale) => {
  const base = DEFAULT_WEBSITE_CONTENT;
  const globalContent = settings?.websiteContent || {};
  const globalLocalized =
    locale && globalContent?.translations?.[locale] ? globalContent.translations[locale] : {};

  const partnerContentRaw = partner?.storefrontContent || {};
  const partnerContent = partnerContentRaw && typeof partnerContentRaw === 'object' ? partnerContentRaw : {};
  const partnerLocalized =
    locale && partnerContent?.translations?.[locale] ? partnerContent.translations[locale] : {};

  return mergeDeep(base, mergeDeep(mergeDeep(globalContent, globalLocalized), mergeDeep(partnerContent, partnerLocalized)));
};
